import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useSocket } from "../../../Context/SocketContext";
import { useSelector } from "react-redux";

export const ChatContext = createContext();

export function useChatContext() {
  return useContext(ChatContext);
}

export default function ChatContextProvider({ children }) {
  const socket = useSocket();
  const isSocketConnected = useSelector((state) => state.auth.isSocketConnected);

  const INITIAL_CHAT_THREAD = useMemo(() => {
    return {
      isError: false,
      isLoading: true,
      data: [],
    };
  }, []);

  const [chatRoom, setChatRoom] = useState({});

  const [chatThread, setChatThread] = useState(INITIAL_CHAT_THREAD);
  console.log("@@@chatThread:", chatThread);

  useEffect(() => {
    console.log("[ChatContext] isSocketConnected:", isSocketConnected);
    if (!isSocketConnected) return;

    console.log("[ChatContext] Emitting _getSupportThreads");
    socket.emit("_getSupportThreads");
  }, [isSocketConnected]);

  useEffect(() => {
    if (!isSocketConnected) return;

    socket.on("getSupportThreads_", (data) => {
      console.log("[ChatContext] getSupportThreads_ received:", data);
      setChatThread((prev) => ({
        ...prev,
        isLoading: false,
        data: data?.data || [],
      }));
    });

    socket.on("newSupportThread_", (data) => {
      const thread = data?.data;
      if (!thread) return;
      setChatThread((prev) => ({
        ...prev,
        data: [thread, ...prev.data],
      }));
    });

    socket.on("resetMessageCount_", (data) => {
      const chat_room_id = data?.data?.chat_room_id;
      if (!chat_room_id) return;
      setChatThread((prev) => ({
        ...prev,
        data: prev.data.map((item) => {
          if (item.chat_room_id !== chat_room_id) return item;
          return { ...item, unread_message_count: 0 };
        }),
      }));
    });

    return () => {
      socket.dispose("getSupportThreads_");
      socket.dispose("newSupportThread_");
      socket.dispose("resetMessageCount_");
    };
  }, [isSocketConnected]);

  useEffect(() => {
    if (!isSocketConnected) return;

    socket.on("receivedMessage_", (res) => {
      const data = res?.data || {};
      setChatThread((prev) => {
        return {
          ...prev,
          data: prev?.data.map((item) => {
            if (item.chat_room_id !== data?.chat_room_id) return item;
            return {
              ...item,
              last_message: {
                ...item?.last_message,
                message_type: data?.message_type,
                message: data?.message,
                createdAt: data?.message_timestamp,
              },
              unread_message_count:
                chatRoom?.id === data?.chat_room_id
                  ? item?.unread_message_count
                  : item?.unread_message_count + 1,
            };
          }),
        };
      });
    });
  }, [isSocketConnected, chatRoom]);

  const resetMessageCount = (chat_room_id) => {
    setChatThread((prev) => {
      return {
        ...prev,
        data: prev?.data.map((item) => {
          if (item.chat_room_id !== chat_room_id) return item;
          return {
            ...item,
            unread_message_count: 0,
          };
        }),
      };
    });
  };

  const updateLastMessagePayload = (data) => {
    setChatThread((prev) => {
      return {
        ...prev,
        data: prev?.data.map((item) => {
          if (item.chat_room_id !== data?.chat_room_id) return item;
          return {
            ...item,
            last_message: {
              ...item?.last_message,
              message_type: data?.message_type,
              message: data?.message,
              createdAt: data?.message_timestamp,
            },
          };
        }),
      };
    });
  };

  return (
    <ChatContext.Provider
      value={{
        chatThreads: chatThread,
        chatRoom,
        setChatRoom,
        resetMessageCount,
        updateLastMessagePayload,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
}
